/* eslint-disable */
import iconDingwei from '@/assets/img/icon_dingwei.png'

export default {
  map(dom,{lon,lat,zoom=16}){
    let data={resizeEnable: true,zoom,}
    if(lon){
      data={...data,center: [lon, lat]}
    }
   return new AMap.Map(document.getElementById(dom), {
    ...data,
    mapStyle: 'amap://styles/5415d2af821d8107c2bafa18f73bcf5b',
    })
  },
  marker:null,
  icon:{
    size: new AMap.Size(32, 54),
    imageSize:new AMap.Size(32, 54),
    image:iconDingwei,
    imageOffset: new AMap.Pixel(0, 0),
  },
  addMarker(map,{lng=0,lat=0}){
    this.marker = new AMap.Marker({
      icon: new AMap.Icon(this.icon),
      position: new AMap.LngLat(lng, lat),  
    });
    map.add(this.marker);
  },
  removeMarker(map){
    map.remove(this.marker);
  },
  refreshMarker(map,{lng=0,lat=0}){
    if(this.marker){
      this.marker.setPosition([lng, lat]);
      map.setCenter([lng, lat]); 
    }else{
      this.addMarker(map,{lng,lat})
      map.setCenter([lng, lat]); 
    }
  },
  control(map){
    AMap.plugin(['AMap.ToolBar'], ()=>{
      map.addControl(new AMap.ToolBar({
          liteStyle: true
      }));
  });
  }
}